import Model from 'modules/reports/orm/Model'
import React, {useContext} from 'react'
import {SearchSetters} from './useSearch.setters'
import {SearchSort} from './useSearch.sort'
import {SearchState} from './useSearch.state'
import Response from 'modules/reports/orm/Response'

export type SearchContextProps<
  TModel extends Model = any,
  TParams = {},
  TFilters = {},
  TDisplay = {}
> = SearchSetters &
  SearchState<TModel, TParams, TFilters, TDisplay> &
  SearchSort & {
    fetchOffset: (start: number, end: number) => Promise<Response<TModel[]>>
    setRowCapacity: (rows: number) => void
  }

const SearchContext = React.createContext<SearchContextProps>(null as any)

export default SearchContext

export function useSearchContext<
  TModel extends Model = any,
  TParams = {},
  TFilters = {},
  TDisplay = {}
>(): SearchContextProps<TModel, TParams, TFilters, TDisplay> {
  return useContext(SearchContext)
}
